export default __webpack_public_path__ + "static/media/HDTX_Minutes Summary of AGMS of June 24_2024.4f4ec0d1.pdf";